<form [formGroup]="formGroup" class="fugl-meyer">
  @if (pageTitle) {
    <div class="fugl-meyer-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="fugl-meyer-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "section" && !isGroupLabel(element)) {
      <div class="section">
        <b class="section-title">{{ getQuestionTitle(element.title) }}</b>
        @if (getQuestionInstruction(element.title)) {
          <div class="fugl-meyer-instruction">
            {{ getQuestionInstruction(element.title) }}
          </div>
        }
      </div>
    }
    @if (element.type === "section" && isGroupLabel(element)) {
      <div class="fugl-meyer-group-label">
        <b>{{ getQuestionTitle(element.title) }}</b>
        @if (getQuestionInstruction(element.title)) {
          <div class="fugl-meyer-instruction">
            {{ getQuestionInstruction(element.title) }}
          </div>
        }
      </div>
    }
    @if (element.type === "radiogroup") {
      <div
        class="fugl-meyer-row"
        [class.fugl-meyer-waiting]="isWaitingForPartIV(element)"
      >
        <div class="fugl-meyer-q">
          <div class="fugl-meyer-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="fugl-meyer-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="fugl-meyer-a">
          <div class="fugl-meyer-group">
            @for (choice of element.choices; track choice.value) {
              <label class="fugl-meyer-option">
                <input
                  type="radio"
                  [formControlName]="element.name"
                  [value]="choice.value"
                  (click)="onRadioClick(element.name, choice.value)"
                />
                <span class="fugl-meyer-option-text">{{
                  choice.text
                }}</span>
              </label>
            }
          </div>
        </div>
      </div>
    }
    @if (isScoreElement(element)) {
      <div
        class="fugl-meyer-score"
        [class.fugl-meyer-total]="isTotalScoreElement(element)"
      >
        <div class="fugl-meyer-score-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="fugl-meyer-score-value">
          {{ getScoreDisplay(element.name) }} /
          {{ getMaxScore(element.name) }}
        </div>
      </div>
    }
  }
</form>
